// Careline's identity, once: the page's hello carries its version (bridge.ts) and build.mjs writes it into the
// generated manifest. Bump `version` when tools change, so an installed copy is offered the update.
export const APP = {
  id: "com.resatech.talkie.ehr",
  name: "Careline EHR",
  version: "1.5.0",
  description:
    "Fictional primary-care EHR. Review patient charts, document encounters and prepare simulated orders. All data is local to this browser. No real prescriptions, laboratory submissions or clinical advice. Use explicit patient/encounter IDs and current revisions; review exact content before sensitive signing.",
  origin: "https://ehr.touchtalkie.com",
} as const;

/** What the app asks Talkie for: nothing. Its page connects only to its own origin (`connect_domains`
 * is empty, and the vhost serves `connect-src 'self'`). */
export const REQUESTED_CAPABILITIES = { connect_domains: [] as string[] };
